// extracted by mini-css-extract-plugin
export default {"reviewOverlay":"soho-vibe-flow-wrapper_reviewOverlay__G0rL0"};